import React from 'react'
import { Divider, List, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { RootState } from 'dataStore/state'
import NavItem from '../NavItem'
import NavCollapse from '../NavCollapse'

interface IProps {
  /** Группа пунктов меню */
  item: any
}

/**
 * Группа пунктов бокового меню.
 * @param item — группа с children
 */
const NavGroup: React.FC<IProps> = ({ item }) => {
  const { sidebarState } = useSelector((state: RootState) => state.ui)

  const items = item.children?.map((menu: any) => {
    switch (menu.type) {
      case 'collapse':
        return <NavCollapse key={menu.id} menu={menu} level={1} />
      case 'item':
        return <NavItem key={menu.id} item={menu} level={1} />
      default:
        return (
          <Typography key={menu.id} variant='h6' color='error' align='center'>
            Ошибка элемента меню
          </Typography>
        )
    }
  })

  return (
    <>
      <List
        subheader={
          item.title && sidebarState ? (
            <Typography variant='caption' display='block' gutterBottom>
              {item.title}
              {item.caption && (
                <Typography variant='caption' display='block' gutterBottom>
                  {item.caption}
                </Typography>
              )}
            </Typography>
          ) : null
        }
      >
        {items}
      </List>

      <Divider sx={{ mt: 0.25, mb: 1.25 }} />
    </>
  )
}

export default NavGroup
